:host {
    --font-family: var(--klavika-medium, sans-serif);

	/**
	* @prop --color-primary: The primary color of the button (active state).
	* @prop --color-btn-text: initial color of button text.
	* @prop --color-btn-text-inverted: color of button text when button is active.
	*/
}

.pagination {
	display: flex;
	justify-content: center;
	align-items: center;
	gap: 1rem;
	margin-block-end:.5rem;
  }

  .pagination button {
	width:2rem;
	height:2rem;
	border-radius: 2rem;
	color: var(--color-btn-text, black);
	background-color: transparent;
	border: none;
	cursor: pointer;
	transition: background-color 0.2s ease-in-out;
	font-size:1rem;
	font-family:var(--font-family, --klavika-medium);
  }

  .pagination button:not([disabled]).active,
  .pagination button:not([disabled]):hover {
	background-color: var(--color-primary, rgb(--color-primary-blue));
	color: var(--color-btn-text-inverted, white);
  }

  .pagination button.disabled, button[disabled] {
	cursor: not-allowed;
  }